<!--
 * @Description: 需求管理
 * @Author: PF
 * @Date: 2023-12-19 09:31:46
 * @LastEditors: PF
 * @LastEditTime: 2026-09-20 15:37:06
-->
<template>
  <el-dialog class="wp95 hp95" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
    <template #header>
      <div class="header-left">
        <el-icon class="header-icon">
          <Document />
        </el-icon>
        <span class="header-title">需求管理</span>
      </div>
      <div class="header-right">
        <el-button type="info" text @click="closeWindow('openList', emits, false)">
          <el-icon>
            <Close />
          </el-icon>
        </el-button>
      </div>
    </template>
    <el-container>
      <el-header style="padding: 0;">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <el-tab-pane label="添加" :name="0"></el-tab-pane>
          <el-tab-pane :label="row.sscdmc + '需求'" :name="1"></el-tab-pane>
          <el-tab-pane label="所有需求" :name="2"></el-tab-pane>
        </el-tabs>
      </el-header>
      <el-main style="padding: 0;">
        <add v-if="activeName ===  0" :indRow="row" @ReturnData="closeWindow('openList', emits, false)"/>
        <chaxun v-if="activeName ===  1" :indRow="row" />
        <suoyou v-if="activeName ===  2" :indRow="row" />
      </el-main>
    </el-container>
  </el-dialog>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { closeWindow } from '@/api/common.js'
import add from './add.vue'
import chaxun from './chaxun.vue'
import suoyou from './suoyou.vue'

const props = defineProps({ openList: { type: Boolean, required: true } })
const emits = defineEmits(['update:openList'])

const activeName = ref(0)
const row = ref()
watch(
  () => props.openList,
  () => {
    if (props.openList) {
      activeName.value = 0

      const xtcdMc = sessionStorage.getItem('CURRENT_SYSTEM_NAME')
      const cdMc = sessionStorage.getItem('menuName') || '首页'
      row.value = {
        xtid: sessionStorage.getItem('CURRENT_SYSTEM_ID'),
        menuid: sessionStorage.getItem('menuId'),
        xtsy: sessionStorage.getItem('CURRENT_SYSTEM_ID') ? undefined : 1,
        xtMc: xtcdMc,
        cdMc: cdMc,
        sscdmc: (xtcdMc ? xtcdMc + '-' : '') + (cdMc || '')
      }
    }
  },
  { deep: true, immediate: true }
)

</script>

<style lang="less" scoped>
.list-page {
  padding: 0;
}
</style>
